// NameFilter.js
import React from 'react';
import { useLanguage } from '../../LanguageContext';

const LuogoConservazioneFilter = ({ search_luogo_conservazione, retrieveArtworks, onChangeLuogoConservazione }) => {
  const { selectedLanguage } = useLanguage();
  return (

        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder={selectedLanguage === 'en' ? 'Search by location' : 'Cerca per luogo di conservazione'}
            value={search_luogo_conservazione}
            onChange={onChangeLuogoConservazione}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => retrieveArtworks()}
            >
              {selectedLanguage === 'it' ? 'Cerca' : 'Search'}
            </button>
          </div>
        </div>

  );
};

export default LuogoConservazioneFilter;
